import store from '@/store';
import moment from 'moment'

export const formatDate = {
    title: 'formatDate',
    func: (value: any, format?: string) => {
        if (!value) {
            return '';
        }
        return moment(!isNaN(value) ? parseInt(value) : value).format(format ? format : 'HH:mm:ss DD/MM/YYYY')
    }
}

export const formatCurrency = {
    title: 'formatCurrency',
    func: (value: number | string, symbol?: string) => {
        if (!value) {
            value = '0';
        }
        return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: symbol ? symbol : "VND",
        }).format(parseFloat(`${value}`));
    }
}

export const formatNumber = {
    title: 'formatNumber',
    func: (value: number | string) => {
        if (!value) {
            return '0';
        }
        return new Intl.NumberFormat("de-DE").format(parseFloat(`${value}`));
    }
}

const lang: any = {
    en: require('../lang/en.json')
}

export const translate = {
    title: 'translate',
    func: (value: string, langCode?: string) => {
        if (!value) {
            return value;
        }
        if (langCode === 'vi') {
            return value;
        }
        if (!langCode && store.state.langCode === 'vi') {
            return value;
        }
        if (langCode && lang[langCode]) {
            const item = lang[langCode][value];
            if (item) {
                return item;
            } else {
                console.log('translate1', value);
            }
        }
        if (!langCode && lang[store.state.langCode]) {

            const item = lang[store.state.langCode][value];
            if (item) {
                return item;
            } else {
                console.log('translate2', value);
            }
        }
        return value;
    }
}
